export default __webpack_public_path__ + "static/vb2-cd8a645a3e307df960227b00f524960d.jpg";